import moment from 'moment'
import PersianDate from 'persian-date'
import { languages, defaultLocale } from '@/locale/index.js'

function strPadLeft (string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length)
}

export const TimeFormatFilter = {
  install: function (Vue) {
    Vue.filter('timeformat', function (time) {
      var minutes = Math.floor(time / 60)
      var seconds = time - minutes * 60
      return strPadLeft(minutes, '0', 2) + ':' + strPadLeft(seconds, '0', 2)
    })
  }
}

export const DateFormatFilter = {
  install: function (Vue) {
    Vue.filter('dateformat', function (unix) {
      if (!unix) {
        return ''
      }
      var offset = moment().utcOffset()
      var date = moment.unix(unix).utcOffset(offset)
      return date.format('lll')
    })
  }
}

export const JalaliDateFormatFilter = {
  install: function (Vue) {
    Vue.filter('jdateformat', function (unix) {
      if (!unix) {
        return ''
      }
      return new PersianDate(unix * 1000).toLocale('fa').format('D MMMM HH:mm')
    })
  }
}

function humanReadable (current, previous) {
  var msPerMinute = 60 * 1000
  var msPerHour = msPerMinute * 60
  var msPerDay = msPerHour * 24
  var msPerMonth = msPerDay * 30
  var msPerYear = msPerDay * 365
  var elapsed = current - previous
  if (elapsed < msPerMinute) {
    return Math.round(elapsed / 1000) + ' ' + languages[defaultLocale]['comment']['seconds_ago']
  } else if (elapsed < msPerHour) {
    return Math.round(elapsed / msPerMinute) + ' ' + languages[defaultLocale]['comment']['minutes_ago']
  } else if (elapsed < msPerDay) {
    return Math.round(elapsed / msPerHour) + ' ' + languages[defaultLocale]['comment']['hours_ago']
  } else if (elapsed < msPerMonth) {
    return Math.round(elapsed / msPerDay) + ' ' + languages[defaultLocale]['comment']['days_ago']
  } else if (elapsed < msPerYear) {
    return Math.round(elapsed / msPerMonth) + ' ' + languages[defaultLocale]['comment']['months_ago']
  } else {
    return Math.round(elapsed / msPerYear) + ' ' + languages[defaultLocale]['comment']['years_ago']
  }
}

export function timeDifference (item) {
  var offset = moment().utcOffset()
  return humanReadable(new Date(), moment.unix(item).utcOffset(offset).toDate())
}

export function yearDifference (item) {
  var msPerMinute = 60 * 1000
  var msPerHour = msPerMinute * 60
  var msPerDay = msPerHour * 24
  var msPerYear = msPerDay * 365
  var offset = moment().utcOffset()
  var elapsed = new Date() - moment.unix(item).utcOffset(offset).toDate()
  return Math.round(elapsed / msPerYear)
}

export function dayDifference (from, to) {
  var msPerMinute = 60 * 1000
  var msPerHour = msPerMinute * 60
  var msPerDay = msPerHour * 24
  var offset = moment().utcOffset()
  var elapsed = moment.unix(to).utcOffset(offset).toDate() - moment.unix(from).utcOffset(offset).toDate()
  return Math.round(elapsed / msPerDay)
}



// WEBPACK FOOTER //
// ./src/_helpers/time-format-filter.js